<template>
    <section class="layout">
        <SidebarLayout @change-view="changeView"></SidebarLayout>
        
        <main class="main-content">
            <NavigationLayout></NavigationLayout>

            <section class="view">
                <component :is="currentView"></component>
            </section>
        </main>
    </section>
</template>

<script>
import { markRaw } from 'vue';
import SidebarLayout from "./components/layout/SidebarLayout.vue";
import NavigationLayout from "./components/layout/NavigationLayout.vue";
import HomeView from "./components/views/HomeView.vue";
import ForewordView from "./components/views/ForewordView.vue";
import TransportAndEconomy from "./components/views/TransportAndEconomy.vue";
import DocumentView from "./components/views/DocumentView.vue";

export default {
    name: "App",
    components: {
        SidebarLayout,
        NavigationLayout,
        HomeView: markRaw(HomeView),
        ForewordView: markRaw(ForewordView),
        TransportAndEconomy: markRaw(TransportAndEconomy),
        DocumentView: markRaw(DocumentView),
    },
    data() {
        return {
            currentView: HomeView,
        };
    },
    created() {
        document.title = "Key figures on European transport";
    },
    methods: {
        changeView(view) {
            this.currentView = view;
        },
    }
};
</script>

<style lang="scss">
    @import "@/assets/styles/main.scss";
</style>
